import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { SubmitFormStepAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function submitReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== SubmitFormStepAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isSubmitted) {
    return state;
  }

  return {
    ...state,
    isSubmitted: true,
    isUnsubmitted: false,
  };
}
